import type {
  activationCredentialsType,
  credentialType,
  editUserPasswordType,
  editUserPersonalInfoType,
  registerCredentialType,
} from "utils";
import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";
import { getAppConfiguration } from "appConfig";

export async function createToken(payload: credentialType) {
  return axiosFetch.post("/security/createToken", payload);
}

export async function getUser() {
  return axiosFetch.post("/security/getUser");
}

export async function putUpdateUserDetails(body: editUserPersonalInfoType) {
  return axiosFetch.put("/security/updateProfileInfo", body);
}

export async function postChangePassword(body: editUserPasswordType) {
  return axiosFetch.post("/security/changePassword", body);
}

export async function postForgotPassword(email: string) {
  const appConfiguration = await getAppConfiguration();
  return axiosFetch.post("/security/forgotPassword", {
    email,
    websiteUrl: `${window.location.protocol}//${window.location.host}`,
    providerId: appConfiguration.providerId,
  });
}

export async function postResetPassword(
  userId: string,
  token: string,
  newPassword: string
) {
  return axiosFetch.post("/security/resetForgotPassword", {
    userId,
    token,
    newPassword,
  });
}

export async function postRegistration(body: registerCredentialType) {
  return axiosFetch.post("/security/register", body);
}

export async function postAccountActivate(payload: activationCredentialsType) {
  return axiosFetch.post("/security/acceptActivation", payload);
}

export async function validateForPayment(email: string, password: string) {
  return axiosFetch.post("/security/validateForPayment", { email, password });
}
